import styled from 'styled-components';

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 500px;
  max-width: 600px;
`;
